var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPkgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 2,
    fill: "#D62626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 30.9167C15.6163 30.9191 11.6632 28.3812 9.98529 24.4871C8.30739 20.593 9.23549 16.1105 12.3365 13.1312C15.0744 10.4986 19.065 9.47049 22.805 10.4341C26.5451 11.3977 29.4664 14.2066 30.4685 17.8028C31.4707 21.399 30.4014 25.2361 27.6635 27.8687C25.6349 29.8281 22.8753 30.9257 20 30.9167ZM11.3333 20.6792C11.3846 25.2638 15.2778 28.9474 20.0461 28.9229C24.8143 28.8981 28.6661 25.1745 28.6661 20.5896C28.6661 16.0047 24.8143 12.281 20.0461 12.2562C15.2778 12.2317 11.3846 15.9154 11.3333 20.5V20.6792ZM17.1931 24.6667L15.6666 23.1979L18.4725 20.5L15.6666 17.8021L17.1941 16.3333L20 19.0312L22.8058 16.3333L24.3333 17.8021L21.5275 20.5L24.3333 23.1979L22.8069 24.6667L20 21.9687L17.1941 24.6667H17.1931Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPkgCancel);
export default __webpack_public_path__ + "static/media/pkgCancel.1fc5f26df2fc688b96d07a9473b03c97.svg";
export { ForwardRef as ReactComponent };